
<app-fr-card *ngIf="checkIfEndedAndNoSupportFr()" class="card-container">
  <mat-card-header class="card-header">
    <div class="icon-header" mat-card-avatar>
      <mat-icon color="primary" class="card-header-icon icon-support-fr"></mat-icon>
    </div>
    <mat-card-title class="card-header-label">Fundraising Team</mat-card-title>
  </mat-card-header>
  <div class="card-line"></div>
  <mat-card-content>
    <div *ngIf="showStartSupportFr && !isFundraiserEnded && !isPending" (click)="openDialog(loginPopupTemp)" class="start-supporting-fr">
      <div class="add"><mat-icon class="icon">add</mat-icon></div>
      <div class="label-fr">
        <div class="txt">Start a Supporting Fundraiser</div>
        <mat-icon class="icon">keyboard_arrow_right</mat-icon>
      </div>
    </div>
    <div (click)="goToMySupportFr(mySopportFr)" *ngIf="!showStartSupportFr && !isPending" class="start-supporting-fr">
      <div class="txt">View my Supporting Fundraiser</div>
      <mat-icon class="icon ml-2">keyboard_arrow_right</mat-icon>
    </div>
    <div #listContainer>
      <app-placeholder-loader class="loader" *ngIf="isLoading" type="donor" [count]="5"></app-placeholder-loader>
      <div class="donor-list" *ngIf="!isLoading">
        <app-donor class="donor" *ngFor="let donor of supporters?.data" [donor]="donor"
                  type="supporter" (click)="goToMySupportFr(donor)">
        </app-donor>
      </div>
    </div>
    <div *ngIf="supporters?.last_page > 1" class="card-pagination">
      <button type="button" [disabled]="page<=1" (click)="setPagination('back')" mat-icon-button><mat-icon>keyboard_arrow_left</mat-icon></button>
      <div class="card-pagination-label">
        <em>{{supporters?.from}} - {{supporters?.to}}</em> of <span>{{supporters?.total}} fundraisers</span>
      </div>
      <button type="button" [disabled]="page==supporters?.last_page" (click)="setPagination('next')" mat-icon-button><mat-icon>keyboard_arrow_right</mat-icon></button>
    </div>
  </mat-card-content>
</app-fr-card>

<ng-template #loginPopupTemp>
  <app-module-loader moduleId="login-popup" selector="app-login-popup" [load]="true"></app-module-loader>
</ng-template>